export default "__VITE_ASSET__bdb29655__"